import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { updateWorkOrderFormValidation } from "../store/workOrder/workOrderSlice";

export const useResetValidationOnClose = (fieldNames) => {
  const dispatch = useDispatch();
  const fieldsRef = useRef(fieldNames);
  fieldsRef.current = fieldNames;

  useEffect(
    () => () => {
      fieldsRef.current?.forEach((fieldName) =>
        dispatch(updateWorkOrderFormValidation({ fieldName, data: false })),
      );
    },
    [dispatch],
  );
};

export default useResetValidationOnClose;
